module.exports = __webpack_public_path__ + "img/thumb_07.ea4abf90.jpg";